const POPPER_INJECTION_KEY = /* @__PURE__ */ Symbol("popper");
const POPPER_CONTENT_INJECTION_KEY = /* @__PURE__ */ Symbol("popperContent");

export { POPPER_CONTENT_INJECTION_KEY, POPPER_INJECTION_KEY };
//# sourceMappingURL=constants.mjs.map
